/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { useEffect, useRef } from "react";
import "./RessourcesContainer.scss";
import PropTypes from "prop-types";
import BtnTransparent from "Components/Boutons/BtnTransparent/btn-transparent";
import Loader from "Components/Loader/loader";
import RessourceCard from "../RessourceCard/RessourceCard";
import Pagination from "Components/Pagination/Pagination";
import { connect } from "react-redux";
import { updatePagination } from "Redux/Actions/paginationActions";
import { Link } from "react-router-dom";
import { updateMenu } from "Redux/Actions/menuActions";
import { useFetchGet } from "Services/api";
import { updateRessources } from "Redux/Actions/ressourcesActions";
import {
  findItemInEditManagementVisibility,
  findManagementContentByLabel,
} from "Services/functions";

const RessourcesContainer = (props) => {
  const ressourcesRef = useRef(null);
  const ressourcesDate = useFetchGet("/resources/univ");
  useEffect(() => {
    //? Remise à zéro des informations de paginations pour ne pas interférer les affichages des autres pages
    return () => {
      props.handleUpdatePagination({ currentPage: 1 });
      props.handleUpdatePagination({ paginationBasicFirst: 0 });
      props.handleUpdatePagination({ paginationBasicRows: 12 });
    };
  }, []);

  useEffect(() => {
    ressourcesDate.loaded &&
      props.handleUpdateRessources({
        ressourcesData: ressourcesDate.data,
      });
  }, [ressourcesDate.loaded]);
  return findItemInEditManagementVisibility(
    "visibleConseils",
    props.admin.editManagementBoolean
  ) ? (
    <div>
      <div className="ressources_container">
        <h1 className="h1_trait_dessus">RESSOURCES ET GUIDES</h1>
        <div className="liste">
          {/* On affiche les 5 derniers conseils publics */}
          {props.ressources?.ressourcesData?.length > 0 ? (
            <div>
              {props.pageRessources == "accueil"
                ? props.ressources.ressourcesData
                    // .slice(-5)
                    .slice(-5)
                    .reverse()
                    .map((ressource) => (
                      <RessourceCard
                        key={ressource.id}
                        name={ressource.name}
                        dataRessource={ressource}
                        size={ressource.size}
                        iconeConseil={ressource.id % 3}
                      />
                    ))
                : props.ressources.ressourcesData
                    // .slice(-5)
                    .slice(
                      props.pagination.paginationBasicFirst,
                      props.pagination.paginationBasicRows *
                        props.pagination.currentPage
                    )
                    .reverse()
                    .map((ressource) => (
                      <RessourceCard
                        key={ressource.id}
                        name={ressource.name}
                        dataRessource={ressource}
                        size={ressource.size}
                        iconeConseil={ressource.id % 3}
                      />
                    ))}
            </div>
          ) : (
            <Loader />
          )}
        </div>

        <div className="ressources_container__pagination">
          {props.pageRessources == "accueil" ? (
            props.auth.isAdmin ? (
              <Link to="/actualites">
                <BtnTransparent
                  btnTexte={`Gérer les ${
                    findManagementContentByLabel(
                      "conseilsTitle",
                      props.admin.editManagement,
                      props.admin.editManagementNexus,
                      props.auth.universityConnected.id
                    ).content
                  }`}
                  btnAction={() => {
                    props.handleMenu({
                      activeItemActuAdmin: props.items.itemsActuAdmin.findIndex(
                        (v) => v.label == "Gérer les actus/conseils"
                      ),
                    });
                  }}
                />
              </Link>
            ) : (
              <Link to="/profil">
                <BtnTransparent
                  btnTexte={`Découvrir mes ${
                    findManagementContentByLabel(
                      "conseilsTitle",
                      props.admin.editManagement,
                      props.admin.editManagementNexus,
                      props.auth.universityConnected.id
                    ).content
                  }`}
                  btnAction={() => {
                    props.handleMenu({
                      activeItemProfil: props.items.itemsProfil.findIndex(
                        (v) => v.label == "Ressources et guides"
                      ),
                    });
                  }}
                />
              </Link>
            )
          ) : (
            <Pagination
              data={props.ressources.ressourcesData}
              refItemParent={ressourcesRef}
            />
          )}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

RessourcesContainer.propTypes = {
  items: PropTypes.object,
  activeIndex: PropTypes.number,
  title: PropTypes.string,
  pageRessources: PropTypes.string,
  pagination: PropTypes.object,
  handleMenu: PropTypes.func,
  auth: PropTypes.object,
  admin: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  ressources: PropTypes.object,
  handleUpdateRessources: PropTypes.func,
};

const mapStateToProps = (state) => ({
  items: state.items,
  auth: state.auth,
  pagination: state.pagination,
  ressources: state.ressources,
  admin: state.admin,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => dispatch(updatePagination(value)),
  handleMenu: (value) => dispatch(updateMenu(value)),
  handleUpdateRessources: (value) => {
    dispatch(updateRessources(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RessourcesContainer);
